import dayjs from 'dayjs';
import React from 'react';
import PropTypes from 'prop-types';
import { shortDate } from '../../../../utils';

/**
 * Small Opening Hours Table for Stores. It's now on the Product Page.
 * The state is shown using styles
 *
 * @param props
 *  children: will be inserted above tbody, eg for the table caption
 *  openingHours: an opening hours array
 *  className: classes to be inserted on the table element
 *  country: country for determining bank holidays
 *  nationwideBankHolidays: list of Nation Wide Bank Holidays based on country
 *  locationBasedBankHolidays: list of Location Based Bank Holidays based on country
 */
export default function SmallTwoColumnsOpeningHoursTable(props) {
  const {
    className,
    children,
    openingHours,
    storeOpenState
  } = props;

  return (
    <table className={className}>
      {children}
      <tbody>
        {openingHours.map((dayOpeningHours, index) => (
          <tr key={index}>
            {getFirstColumnCell(props, index)}
            <td>{dayOpeningHours}</td>
            {(index === 0) && getStoreLabel(storeOpenState)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function getFirstColumnCell(params, index) {
  const {
    country,
    nationwideBankHolidays,
    locationBasedBankHolidays,
    currentDate
  } = params;

  const currentDateFormatted = dayjs(currentDate).add(index, 'days').format('YYYY/MM/DD');

  let firstColumnCellContent;

  if (country &&
    locationBasedBankHolidays[country] &&
    locationBasedBankHolidays[country][currentDateFormatted]) {

    firstColumnCellContent = <td>{locationBasedBankHolidays[country][currentDateFormatted]}</td>;
  } else if (nationwideBankHolidays[currentDateFormatted]) {

    firstColumnCellContent = <td>{nationwideBankHolidays[currentDateFormatted]}</td>;
  } else {

    firstColumnCellContent = <td>{shortDate(currentDate, index)}</td>;
  }

  return firstColumnCellContent;
}

function getStoreLabel(storeOpenState) {
  if (storeOpenState === 'open' ||
    storeOpenState === 'closing_soon') {
    return <td className={'storeLabel'}>Open</td>;
  } if (storeOpenState === 'closed') {
    return <td className={'storeLabel'}>Closed</td>;
  }

  return '';
}

SmallTwoColumnsOpeningHoursTable.propTypes = {
  children: PropTypes.node,
  openingHours: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  country: PropTypes.string.isRequired,
  nationwideBankHolidays: PropTypes.objectOf(PropTypes.string).isRequired,
  locationBasedBankHolidays: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  storeOpenState: PropTypes.string.isRequired,
  currentDate: PropTypes.objectOf(Date).isRequired
};

SmallTwoColumnsOpeningHoursTable.defaultProps = {
  children: null,
  className: ''
};
